export default "__VITE_ASSET__CAx4YsET__"